<script lang="ts">
    import type {Sorting} from 'typings/portaro.be.types';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {getLocalization} from 'core/svelte-context/context';
    import {createEventDispatcher} from 'svelte';

    export let selectedSorting: Sorting;
    export let availableSortings: Sorting[];

    const dispatch = createEventDispatcher<{ 'change-sorting': Sorting }>();
    const localize = getLocalization();

    function changeSorting() {
        dispatch('change-sorting', selectedSorting);
    }
</script>

<span>
    <label for="search-sorting-select">{localize(/* @kp-localization hledani.razeni.SeraditVysledkyPodle */ 'hledani.razeni.SeraditVysledkyPodle')}:</label>
    <select id="search-sorting-select" bind:value={selectedSorting} on:change={changeSorting}>
        {#each availableSortings as sorting (sorting.id)}
            <option value={sorting}>
                {pipe(sorting, loc())}
            </option>
        {/each}
    </select>
</span>